module.exports = __webpack_public_path__ + "static/media/Medidas_3_4_5_6.9013d86b.pdf";